<template>
  <div class="footer-cont">
    <div v-if="matchRoutes" class="footer-container hide-small">
      <div class="footer-content content">
        <div class="link-container">
          <a class="link" @click="_ => $router.push({ name: 'landing' })">{{ $t('home') }}</a>
          <a class="link" @click="_ => $router.push({ name: 'legal' })">{{ $t('legalInfo') }}</a>
          <a class="link" @click="_ => $router.push({ name: 'cgv' })">{{ $t('cgv') }}</a>
          <a class="link" @click="_ => $router.push({ name: 'rgpd' })">{{ $t('rgpd.title') }}</a>
          <a class="link" @click="_ => $router.push({ name: 'cookies' })">{{ $t('cookiesPolicy') }}</a>
          <a class="link" @click="_ => $router.push({ name: 'contact' })">{{ $t('contact') }}</a>
        </div>

        <div class="copyright-container">
          <div>{{ $t('copyright') }}</div>
        </div>
      </div>
    </div>
    <div v-else class="footer-container landing">
      <div class="title">Envie d'en savoir plus ?</div>
      <div class="access-button">
        <div class="btn try" @click="_ => $router.push({ name: 'contact' })">Contact</div>
      </div>
      <div class="footer-content content">
        <div class="link-container">
          <a class="link" @click="_ => $router.push({ name: 'landing' })">{{ $t('home') }}</a>
          <a class="link" @click="_ => $router.push({ name: 'legal' })">{{ $t('legalInfo') }}</a>
          <a class="link" @click="_ => $router.push({ name: 'cgv' })">{{ $t('cgv') }}</a>
          <a class="link" @click="_ => $router.push({ name: 'rgpd' })">{{ $t('rgpd.title') }}</a>
          <a class="link" @click="_ => $router.push({ name: 'cookies' })">{{ $t('cookiesPolicy') }}</a>
          <a class="link" @click="_ => $router.push({ name: 'contact' })">{{ $t('contact') }}</a>
        </div>

        <div class="copyright-container">
          <div>{{ $t('copyright') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    matchRoutes() {
      return this.$route.name !== 'landing';
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
.footer-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: colors.$main-color;
  height: 64px;
  box-sizing: border-box;
  flex-wrap: wrap;

  &.landing {
    height: 400px;
    background: url(~@/assets/landing/section.png);
    flex-direction: column;
    justify-content: flex-end;
    padding-bottom: 26px;
    .title {
      font-weight: 500;
      font-size: 32px;
      color: #ffffff;
    }

    .access-button {
      margin-top: 50px;
      margin-bottom: 140px;
      display: flex;
      align-items: center;
      justify-content: center;
      .btn {
        font-weight: 500;
        font-size: 16px;
        text-align: center;
        color: #ffffff;
        padding: 15px 47px;
        border-radius: 30px;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
          opacity: 0.8;
          transform: scale(1.05);
        }

        &.try {
          background: #88d388;
          border: 1px solid #88d388;
        }

        &.contact {
          margin-left: 25px;
          border: 1px solid #fff;
        }
      }
    }
    @media only screen and (max-width: responsive.$layout-breakpoint-small) {
      justify-content: center;
      align-items: center;
      flex-direction: row;
      height: 563px;
      padding: 60px 0;

      .access-button {
        flex-direction: column;
        margin-bottom: 20px;
        .try {
          margin-bottom: 24px;
        }
        .contact {
          margin-left: 0 !important;
        }
      }

      .footer-content {
        box-sizing: border-box;
        justify-content: center;
        align-items: center;

        .link-container {
          flex-direction: column;
          width: 100%;
          box-sizing: border-box;

          .link {
            margin: 10px 0 !important;
            box-sizing: border-box;
          }
        }

        .copyright-container {
          margin-top: 22px;
          box-sizing: border-box;
        }
      }
    }
  }

  .footer-content {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;

    .link-container,
    .copyright-container {
      margin: 0;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      font-size: 14px;
      color: colors.$white-color;

      .link {
        margin: 0 14px;

        &:hover {
          cursor: pointer;
          opacity: 0.7;
        }

        &:first-child {
          margin: 0 14px 0 0;
        }
      }

      &:nth-child(2n) {
        font-size: 13px;
        justify-content: flex-end;
      }
    }
  }
}
</style>
